import React from 'react';
import { Switch } from 'react-router-dom';

import { FeatureFlag } from 'app/api/services/site-configs/types';
import { ExtendedRouteProps } from 'app/lib/routing/types';

import { RedirectToAliasesOrNotFound, RouteWithSubRoutes } from 'app/lib/routing';
import { ROUTE_PATH } from 'app/lib/routing/constants';
import Cashback from 'app/modules/Cashback';
import { Download } from 'app/modules/Download/Download';
import ExternalGameById from 'app/modules/ExternalGameById';
import ExternalGames from 'app/modules/ExternalGames';
import { FavoritesPage } from 'app/modules/Favorites/FavoritesPage';
import History from 'app/modules/History';
import LandingPage from 'app/modules/LandingPage';
import LayoutWithSideBars from 'app/modules/Layout/LayoutWithSidebars';
import LivePage from 'app/modules/Live';
import { MatchResult } from 'app/modules/MatchResult';
import { ActiveStakes, HistoryStakes } from 'app/modules/MyStakes';
import { NotFound } from 'app/modules/NotFound';
import { DepositPage, WithdrawalPage } from 'app/modules/Payment';
import { Gifts, Notifications, PersonalData, UserSettings } from 'app/modules/Personal';
import { PrematchPage } from 'app/modules/Prematch';
import Promotions from 'app/modules/Promotions';
import ResultsPage from 'app/modules/Results';

const routes: ExtendedRouteProps[] = [
  {
    exact: true,
    path: ROUTE_PATH.DOWNLOAD,
    component: Download,
  },
  {
    exact: true,
    ff: FeatureFlag.ALLOW_GAMES,
    path: `${ROUTE_PATH.EXTERNAL_GAMES}/:id`,
    component: ExternalGameById,
  },
  {
    exact: true,
    path: ROUTE_PATH.NOT_FOUND,
    component: NotFound,
  },
  {
    path: ROUTE_PATH.ROOT,
    component: LayoutWithSideBars,
    routes: [
      {
        exact: true,
        path: ROUTE_PATH.ROOT,
        component: LandingPage,
      },
      {
        exact: true,
        ff: FeatureFlag.ALLOW_GAMES,
        path: ROUTE_PATH.EXTERNAL_GAMES,
        component: ExternalGames,
      },
      {
        path: ROUTE_PATH.PROMOTIONS,
        ff: FeatureFlag.PROMOTIONS,
        component: Promotions,
      },
      {
        path: ROUTE_PATH.PREMATCH,
        component: PrematchPage,
      },
      {
        path: ROUTE_PATH.FAVORITES,
        component: FavoritesPage,
      },
      {
        path: ROUTE_PATH.LIVE,
        component: LivePage,
      },
      {
        exact: true,
        path: ROUTE_PATH.RESULTS,
        component: ResultsPage,
      },
      {
        path: ROUTE_PATH.RESULTS,
        component: MatchResult,
      },
      {
        exact: true,
        private: true,
        path: ROUTE_PATH.PERSONAL,
        component: PersonalData,
      },
      {
        exact: true,
        private: true,
        path: ROUTE_PATH.GIFTS,
        component: Gifts,
      },
      {
        private: true,
        path: `${ROUTE_PATH.DEPOSIT}/:providerId?`,
        component: DepositPage,
      },
      {
        private: true,
        path: `${ROUTE_PATH.WITHDRAWAL}/:providerId?`,
        component: WithdrawalPage,
      },
      {
        private: true,
        path: ROUTE_PATH.ACTIVE_STAKES,
        component: ActiveStakes,
      },
      {
        private: true,
        path: ROUTE_PATH.HISTORY_STAKES,
        component: HistoryStakes,
      },
      {
        private: true,
        path: ROUTE_PATH.HISTORY,
        component: History,
      },
      {
        private: true,
        path: ROUTE_PATH.NOTIFICATIONS,
        component: Notifications,
      },
      {
        private: true,
        ff: FeatureFlag.CASHBACK,
        path: ROUTE_PATH.CASHBACK,
        component: Cashback,
      },
      {
        private: true,
        path: ROUTE_PATH.SETTINGS,
        component: UserSettings,
      },
      {
        component: RedirectToAliasesOrNotFound,
      },
    ],
  },
];

export default () => (
  <Switch>
    {routes.map((route, i) => (
      <RouteWithSubRoutes
        key={i}
        {...route} />
    ))}
  </Switch>
);
